import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { merge } from "lodash";
import { languages } from "@esfirus/n-backoffice";
import es from "./es.json";

i18n.use(initReactI18next).init({
  fallbackLng: "es",
  debug: true,
  resources: {
    es: merge({}, es, languages.es),
  },
});

export default i18n;
